import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const ONE_HOUR = 1000 * 60 * 60;

export const useMaternityHospitals = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["maternity-hospitals", tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/mncms/maternity-hospitals`
      );
      const hospitals = response.data?.data ?? response.data ?? [];

      return hospitals.map((hospital) => ({
        value: hospital.healthlinkId,
        label: hospital.name,
      }));
    },
    enabled: !!tenantVal,
    // Reference data shared across tenants, changes rarely — safe to cache.
    staleTime: ONE_HOUR,
  });
};
